"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { MobileComparisonBadge } from "./mobile-comparison-badge";
import { DesktopComparisonBadge } from "./desktop-comparison-badge";
export function MinimizedComparisonBadge() {
  const $ = _c(4);
  const [isMobile, setIsMobile] = useState(false);
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
      const checkMobile = () => {
        setIsMobile(window.innerWidth < 768);
      };
      checkMobile();
      window.addEventListener("resize", checkMobile);
      return () => window.removeEventListener("resize", checkMobile);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    return null;
  }
  let t2;
  if ($[2] !== isMobile) {
    t2 = isMobile ? <MobileComparisonBadge /> : <DesktopComparisonBadge />;
    $[2] = isMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}